<template>
  <div class="mc-report-view__table">
    <div class="row mb-3">
      <div class="col-md-6">
        <b-button-group class="mb-3">
          <b-button
            @click="isTable = true"
            :variant="isTable ? 'success' : 'secondary'"
            ><i class="icon-outline_browser"></i> Table</b-button
          >
          <b-button
            @click="isTable = false"
            :variant="isTable ? 'secondary' : 'success'"
            ><i class="icon-fill_activity"></i> Grafik</b-button
          >
        </b-button-group>
      </div>

      <!-- Search -->
      <div class="col-md-6">
        <div class="mc-table-view" v-if="isTable">
          <div
            id="tickets-table_filter"
            class="dataTables_filter text-md-end float-end"
          >
            <label
              class="d-inline-flex align-items-center mc-table-view__search"
            >
              <i class="mc-fa fas fa-search"></i>
              <b-form-input
                v-model="filter"
                type="search"
                :placeholder="$t('global.search') + '...'"
                class="ms-2"
              ></b-form-input>
            </label>
          </div>
        </div>
      </div>
      <!-- End search -->
    </div>

    <div class="table-responsive my-3 border border-1" v-if="isTable">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-card>
            <b-skeleton-table
              :rows="3"
              :columns="fields.length"
              :table-props="{ bordered: false, striped: true }"
            >
            </b-skeleton-table>
          </b-card>
        </template>
        <b-table
          id="fuelTable"
          class="datatables"
          :items="reportFuel"
          :fields="fields"
          :current-page="currentPage"
          responsive="md"
          show-empty
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :empty-filtered-text="$t('global.emptyFilteredTable')"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(createdOn)="data">
            {{ momentDateShortMonth(data.item.createdOn) }}<br />
            <span class="text-muted">{{
              momentTimeSeconds(data.item.createdOn)
            }}</span>
          </template>
          <template #cell(vehicle)="data">
            {{
              data.item.vehicle.licensePlate
                ? data.item.vehicle.licensePlate
                : "-"
            }}
          </template>

          <template #cell(vehicleType)="data">
            {{
              data.item.vehicle
                ? data.item.vehicle.vehicleType
                  ? data.item.vehicle.vehicleType.manufacturer
                  : "-"
                : "-"
            }}
            /
            {{
              data.item.vehicle
                ? data.item.vehicle.vehicleType
                  ? data.item.vehicle.vehicleType.model
                  : "-"
                : "-"
            }}
            /
            {{
              data.item.vehicle
                ? data.item.vehicle.vehicleType
                  ? data.item.vehicle.vehicleType.type
                  : "-"
                : "-"
            }}
          </template>
        </b-table>
      </b-skeleton-wrapper>
    </div>
    <div class="row mt-3" v-if="isTable">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Menampilkan
            <b-form-select
              class="form-select form-select-sm"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            >
            </b-form-select>
            entri. <p>Menampilkan <strong>{{
              filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
            }}</strong
            > - <strong>{{
              Math.min(totalRows, currentPage * perPage)
            }}</strong
            > dari <strong>{{ totalRows }}</strong
            ></p>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows == null ? rows : totalRows"
              :per-page="perPage"
              aria-controls="fuelTable"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="!isTable">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-skeleton-img no-aspect height="400px"></b-skeleton-img>
        </template>
        <MixedChart
          :labels="chartData.labels"
          :datasets="chartData.datasets"
          :start-timestamp="start"
          :end-timestamp="end"
          yLabel="Volume"
        >
        </MixedChart>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import MixedChart from "@/components/Chart/MixedChart.vue";
import { GET_REPORT_FUEL } from "@/services/api/report/report";
import moment from "moment";
import { Helper } from "@/mixin/helper";
import { Export } from "@/mixin/export";
import {
  EXPORT_PDF_CHART_FUEL,
  EXPORT_PDF_REPORT_FUEL,
} from "@/services/api/report/pdf";
import { EXPORT_EXCEL_REPORT_FUEL } from "@/services/api/report/excel";
moment.locale("id");

export default {
  name: "FuelTable",
  components: {
    MixedChart,
  },
  mixins: [Helper, Export],
  data() {
    return {
      isTable: true,
      series: [
        {
          name: "Fuel (Liter)",
          data: [84, 94, 104, 71],
        },
        {
          name: "Fuel (%)",
          data: [56, 66, 76, 43],
        },
        {
          name: "Speed (Km/h)",
          data: [38, 48, 58, 26],
        },
        {
          name: "ACC",
          data: [31, 41, 51, 19],
        },
      ],
      chartData: {
        labels: [],
        datasets: [],
      },
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      reportFuel: [],
      fields: [],
      isLoading: false,
      fileName: "",
      openSection: false,
      periode: [],
      filteredItems: [],
      interval: {
        key: 1,
        label: "1 Menit",
      },
      vehicleId: null,
      start: null,
      end: null,
    };
  },
  computed: {
    rows() {
      return this.reportFuel;
    },
    listData() {
      return this.reportFuel;
    },
  },
  watch: {
    isTable(_, newValue) {
      this.$store.commit("report/changeGraphStatus", !newValue);
    },
  },
  mounted() {
    this.totalRows = this.reportFuel.length;
  },
  methods: {
    /**
     * Search the table data with search input
     */

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    refreshData(periode, filter, interval, fields) {
      if (fields.length == 0) {
        this.reportFuel = [];
        return;
      }
      this.fields = fields;
      this.isLoading = true;
      this.periode = periode;
      this.interval = interval;
      this.vehicleId = parseInt(filter.vehicleId);
      this.start = moment(periode[0]).toISOString();
      this.end = moment(periode[1]).toISOString();
      var filters = {};
      if (filter !== undefined) {
        filters = {
          vehicleId: parseInt(filter.vehicleId),
        };
      }

      let filterVar = {
        startDate: moment(periode[0]).toISOString(),
        endDate: moment(periode[1]).toISOString(),
        driver: false,
        interval: interval.key,
        ...filters,
      };

      var self = this;
      let dataLabels = [];
      let getData = this.$apollo
        .query({
          query: GET_REPORT_FUEL,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var data = res.data;

          self.totalRows = data.reportFuel.reportFuel.length;
          if (data.reportFuel.reportFuel.length === 0) {
            self.reportFuel = [];
            self.isLoading = false;
            return [];
          }
          self.isEmpty = false;

          self.reportFuel = data.reportFuel.reportFuel;
          self.filteredItems = data.reportFuel.reportFuel;
          dataLabels = data.reportFuel.reportFuel.map((item) => item.createdOn);
          self.chartData.labels = [
            ...dataLabels,
            moment(periode[1] + " 23:59:59.000").toISOString(),
          ];
          self.chartData.datasets = [
            {
              type: "line",
              label: "Bahan Bakar (L)",
              data: data.reportFuel.reportFuel.map((item) => item.fuel),
              borderColor: "#3EFEFF",
              fill: false,
              pointRadius: 0,
              lineTension: 0,
              borderWidth: 2,
              spanGaps: true,
            },
            {
              type: "line",
              label: "Bahan Bakar (%)",
              data: data.reportFuel.reportFuel.map(
                (item) => item.fuelPercentage
              ),
              borderColor: "#000096",
              fill: false,
              pointRadius: 0,
              lineTension: 0,
              borderWidth: 2,
              spanGaps: true,
            },
            {
              type: "bar",
              barThickness: 2,
              label: "Kecepatan",
              data: data.reportFuel.reportFuel.map((item) => item.speed),
              borderColor: "#009600",
              backgroundColor: "#009600",
            },
          ];

          self.isLoading = false;
        });

      return getData;
    },

    openTable(periode, filter, interval, fields) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.refreshData(periode, filter, interval, fields);
          this.openSection = false;
        }, 500);
      });
    },

    downloadToExcel(periode, filter, interval, fields) {
      var filters = {};
      if (filter !== undefined) {
        filters = {
          vehicleId: filter.vehicleId,
        };
      }

      var filterVar = {
        startDate: moment(periode[0]).toISOString(),
        endDate: moment(periode[1]).toISOString(),
        subtitle: `Periode : ${this.momentDateLongMonth(
          periode[0]
        )} - ${this.momentDateLongMonth(periode[1])}, Interval : ${
          interval.label
        }`,
        interval: interval.key,
        column: fields.map((item) => item.header),
        driver: false,
        ...filters,
      };

      var downloadProgress = {
        name:
          "Bahan Bakar " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".xlsx",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "excel",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 1000);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_EXCEL_REPORT_FUEL,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var isSuccessful = res.data.excelReportFuel.isSuccessful;
          if (isSuccessful) {
            percentage = 100;
          } else {
            percentage = 90;
          }
          clearInterval(intervalDownload);
          self.$parent.$parent.$parent.refreshDownloadHistory();
          setTimeout(() => {
            self.$store.commit("report/updateProgress", {
              progress: downloadProgress,
              percentage: percentage,
            });
            self.$store.commit("report/deleteProgress", downloadProgress);
          }, 500);
        });
    },

    downloadToPdf(periode, filter, interval, fields) {
      var filters = {};
      if (filter !== undefined) {
        filters = {
          vehicleId: filter.vehicleId,
        };
      }
      var filterVar = {
        startDate: moment(periode[0]).toISOString(),
        endDate: moment(periode[1]).toISOString(),
        interval: interval.key,
        column: fields.map((item) => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(
          periode[0]
        )} - ${this.momentDateLongMonth(periode[1])}, Interval : ${
          interval.label
        }`,
        driver: false,
        ...filters,
      };

      var downloadProgress = {
        name:
          "Bahan Bakar " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".pdf",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "pdf",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 1000);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_PDF_REPORT_FUEL,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var isSuccessful = res.data.pdfReportFuel.isSuccessful;
          if (isSuccessful) {
            percentage = 100;
          } else {
            percentage = 90;
          }
          clearInterval(intervalDownload);
          self.$parent.$parent.$parent.refreshDownloadHistory();
          setTimeout(() => {
            self.$store.commit("report/updateProgress", {
              progress: downloadProgress,
              percentage: percentage,
            });
            self.$store.commit("report/deleteProgress", downloadProgress);
          }, 500);
        });
    },

    downloadGraphToPdf(periode, filter, interval) {
      var filters = {};
      if (filter !== undefined) {
        filters = {
          vehicleId: filter.vehicleId,
        };
      }
      var filterVar = {
        startDate: moment(periode[0]).toISOString(),
        endDate: moment(periode[1]).toISOString(),
        interval: interval.key,
        driver: false,
        ...filters,
      };

      var downloadProgress = {
        name:
          "Grafik Bahan Bakar " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".pdf",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "pdf",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 1000);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_PDF_CHART_FUEL,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var isSuccessful = res.data.pdfChartReportFuel.isSuccessful;
          if (isSuccessful) {
            percentage = 100;
          } else {
            percentage = 90;
          }
          clearInterval(intervalDownload);
          self.$parent.$parent.$parent.refreshDownloadHistory();
          setTimeout(() => {
            self.$store.commit("report/updateProgress", {
              progress: downloadProgress,
              percentage: percentage,
            });
            self.$store.commit("report/deleteProgress", downloadProgress);
          }, 500);
        });
    },
  },
};
</script>
